import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import Select, {createFilter} from "react-select";
import {useHistory, useLocation} from "react-router-dom";
import axios from "axios";
import {getEncryptionKeysBySATermApi, TerminalDataTableListMgmtApi} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";


function MacEncryption({ nextStep, handleChange, values }) {

    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const location = useLocation();
    const [data, setData] = useState();
    const [macCrypt1, setMacCrypt1] = useState();
    const [showTerminalPin, setShowTerminalPin] = useState(false);
    const [terminalOptions, setTerminalOptions] = useState([]);
    const [terminalSelectData, setTerminalSelectData] = useState([]);
    const [selectedTerminal, setSelectedTerminal] = useState();
    const [pending, setPending] = React.useState(true);
    const history = useHistory();

    useEffect(() => {
        const fetchData = async () => {
            let result = await axios.get(
                `getTerminalDetailsByID?termId=${selectedTerminal?.value}&searchCriteria=&lastTxn=10`);
            setData(result.data.response[0]);
        };
        fetchData();
    }, [selectedTerminal]);

    useEffect(() => {

        const fetchResults = async () => {
            let result = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });
            setData(result.data.response);
            setTerminalOptions(result?.data?.response);
            setSelectedTerminal({
                label: result?.data.response?.[0]?.terminalID,
                value: result?.data.response?.[0]?.terminalID,
            });
            setPending(false);
        };
        fetchResults();
        return () => {
            setTerminalOptions([]);
        };
    }, []);

    const handleClick = () => {
        console.log(" continue logeged",selectedTerminal)
        setSelectedTerminal({
            label: selectedTerminal.value,
            value: selectedTerminal.value,
        });
        setShowTerminalPin(true)
    };

    useEffect(() => {

        const fetchResults = async () => {
            let result = await axios.get(`${getEncryptionKeysBySATermApi}?paramTerminalID=${selectedTerminal?.value}`,{
                mode: 'no-cors' // 'cors' by default
            });

            setMacCrypt1(result?.data?.response[0]?.macCrypt1);

            console.log(result?.data?.response[0],"======= ",macCrypt1)
        };
        fetchResults();
    }, [selectedTerminal]);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();
    const onSubmit = (data, e) => {
        e.target.reset(); // reset after form submit
        alert(JSON.stringify(data));
    };

    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <h5 className="tbsub-title mt-3 mb-3"></h5>
                <form>
                    <div className="col-md-12">
                        <div className="form-group row">
                            <label className="control-label col-md-4"><strong><u> Please, select the terminal:</u></strong></label>
                            <div className="input-group col-md-4">
                                <Select
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    options={terminalOptions}
                                    onChange={(e) => setSelectedTerminal(e)}
                                    value={selectedTerminal}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                        }),
                                    }}
                                />

                            </div>
                            <button className="btn btn-primary col-md-3"
                                    type="button" style={{padding:"3px 10px 3px"}}
                                    onClick={() => handleClick()}
                                    value="Go"
                            >Go</button>
                        </div>
                    </div>

                </form>

                { true ?
                <div className="col-md-12">
                    <div className="form-group row">
                        <div className="form-group row col-md-12">
                            <label className="control-label col-md-4"><strong>Terminal ID : <i style={{color:"green"}}>{selectedTerminal.value}</i></strong></label>
                        </div>
                        <div className="form-group row col-md-12">
                            <label className="control-label col-md-4"><strong>MAC(Cryptogram):  {(macCrypt1 !=='null')?macCrypt1:"MAC Key 1 not set"}</strong> </label>
                        </div>
                    </div>
                </div> :"" }
            </div>
        </div>
    );

}

export default MacEncryption;